import React, { useEffect, useState } from 'react';
import { HomePage } from './pages/HomePage';
import { DestinationPage } from './pages/DestinationPage';
import { HotelDetailPage } from './pages/HotelDetailPage';
import { BookingPage } from './pages/BookingPage';
export function App() {
  const [currentPage, setCurrentPage] = useState<string>('');
  const [pageData, setPageData] = useState<{
    type: string;
    id?: string;
    roomId?: string;
  }>({
    type: 'home'
  });
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1); // Remove the #
      // Booking page
      if (hash.startsWith('booking-')) {
        const parts = hash.split('-');
        const hotelId = parts[1];
        const roomId = parts[2];
        setPageData({
          type: 'booking',
          id: hotelId,
          roomId
        });
        setCurrentPage('booking');
      }
      // Hotel detail page
      else if (hash.startsWith('hotel-')) {
        const hotelId = hash.replace('hotel-', '');
        setPageData({
          type: 'hotel',
          id: hotelId
        });
        setCurrentPage('hotel');
      }
      // Destination pages
      else if (hash === 'dubai' || hash === 'kathmandu' || hash === 'france' || hash === 'delhi' || hash === 'paris') {
        setCurrentPage('destination');
        // Map 'france' and 'paris' to same destination, 'delhi' to dubai for now
        const destinationId = hash === 'france' || hash === 'paris' ? 'dubai' : hash === 'delhi' ? 'dubai' : hash;
        setPageData({
          type: 'destination',
          id: destinationId
        });
      }
      // Home page
      else {
        setCurrentPage('home');
        setPageData({
          type: 'home'
        });
      }
    };
    // Initial check
    handleHashChange();
    // Listen for hash changes
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  if (currentPage === 'booking') {
    return <BookingPage data-id="element-0" />;
  }
  if (currentPage === 'hotel') {
    return <HotelDetailPage hotelId={pageData.id} data-id="element-1" />;
  }
  if (currentPage === 'destination') {
    return <DestinationPage destinationId={pageData.id || 'dubai'} data-id="element-2" />;
  }
  return <HomePage data-id="element-3" />;
}